// extracted by mini-css-extract-plugin
export default {"tableHead":"TableHead_tableHead__5qFgw","sortIcons":"TableHead_sortIcons__UdhdZ","activeSort":"TableHead_activeSort__zmRQ0"};